import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setPostKyc = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_KYC
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetKyc({
                    page: 1,
                    rowsPerPage: 10,
                    search: ''
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostKyc as SetPostKyc
}